<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <h1 class="display-1">{{ fabricCategoryID }} tbd fabric name</h1>
        <v-btn fab fixed bottom right color="primary" v-bind:to="{ name: 'New Price' }">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-data-table :headers="headers" :items="prices">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.price }}</td>
              <td>{{ props.item.width }}</td>
              <td>{{ props.item.drop }}</td>
              <td>
                <router-link v-bind:to="{ name: 'Edit Price', params: { id: props.item._id } }">Edit</router-link> |
                <a href="#" @click="deletePrice(props.item._id)">Delete</a>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PriceService from '@/services/PriceService'
export default {
  name: 'prices',
  data () {
    return {
      headers: [
        { text: 'Price', value: 'price' },
        { text: 'Width', value: 'width' },
        { text: 'Drop', value: 'drop' },
        { text: 'Actions', value: 'actions' }
      ],
      prices: [],
      fabricCategoryID: this.$route.params.fabricCategoryID
    }
  },
  mounted () {
    this.getPrices()
  },
  methods: {
    async getPrices () {
      if (this.fabricCategoryID == null) {
        const response = await PriceService.fetchPrices()
        this.prices = response.data.prices
      } else {
        const response = await PriceService.getPricesInCategory(this.fabricCategoryID)
        this.prices = response.data
      }
    },

    async deletePrice (id) {
      await PriceService.deletePrice(id)
      this.getPrices()
      this.$router.push({ name: 'Prices' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/prices/Prices.vue